import { render, staticRenderFns } from "./individualAnalysisCO.vue?vue&type=template&id=ab273c0c&scoped=true"
import script from "./individualAnalysisCO.vue?vue&type=script&lang=js"
export * from "./individualAnalysisCO.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ab273c0c",
  null
  
)

export default component.exports